export const FIELD_UPDATE = 'profile/FIELD_UPDATE';
export const LOAD_INIT = 'profile/LOAD_INIT';
export const LOAD_COMPLETE = 'profile/LOAD_COMPLETE';
export const SAVE = 'profile/SAVE';
export const REMOVE_SNAS = 'profile/REMOVE_SNAS';
export const SAVE_USER_TOKEN = 'profile/SAVE_USER_TOKEN';
export const FETCH_NB_VISITS = 'profile/FETCH_NB_VISITS';
